import ValueObject from './ValueObject';

export default class MetalPlanId extends ValueObject {
  equals(other) {
    if (!(other instanceof MetalPlanId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new MetalPlanId(json);
  }
}
